export default __webpack_public_path__ + "static/media/left-mobile-header-bg.aac88bd6.svg";